(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details-2"] && !Shopify.designMode) return;
  try {
    function copyPromoCodeText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textArea);
      }
    });
  }

  function initPromoCopyButtons() {
    const promoCopyButtons = document.querySelectorAll('.promo-banner__copy-button');

    if (!promoCopyButtons.length) {
      return;
    }

    promoCopyButtons.forEach(button => {
      if (button.dataset.copyBound === 'true') {
        return;
      }

      button.dataset.copyBound = 'true';

      button.addEventListener('click', async () => {
        const promoCode = button.dataset.copyText?.trim();
        const defaultLabel = button.dataset.copyLabel || 'COPY';

        if (!promoCode) {
          return;
        }

        try {
          await copyPromoCodeText(promoCode);
          button.textContent = button.dataset.copiedLabel || 'COPIED!';
          button.classList.add('is-copied');

          if (button.copyResetTimeout) {
            window.clearTimeout(button.copyResetTimeout);
          }

          button.copyResetTimeout = window.setTimeout(() => {
            button.textContent = defaultLabel;
            button.classList.remove('is-copied');
          }, 2000);
        } catch (error) {
          console.error('Failed to copy promo code', error);
        }
      });
    });
  }

  // Buy Now 按钮 - 使用 Storefront API 创建独立 checkout（不影响购物车）
  const STOREFRONT_TOKEN = 'f828427979a7f9ca220b123a9e032dfe';
  const STOREFRONT_ENDPOINT = 'https://oxilam.com/api/2024-10/graphql.json';
  const BUY_NOW_MUTATION = `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          checkoutUrl
        }
        userErrors {
          message
          field
        }
      }
    }
  `;

  async function buyNowKeepCart(variantId, quantity) {
    try {
      const response = await fetch(STOREFRONT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: BUY_NOW_MUTATION,
          variables: {
            input: {
              lines: [{
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                quantity: parseInt(quantity, 10) || 1
              }]
            }
          }
        })
      });

      const data = await response.json();

      if (data.data?.cartCreate?.userErrors?.length) {
        throw new Error(data.data.cartCreate.userErrors[0].message);
      }

      const checkoutUrl = data.data?.cartCreate?.cart?.checkoutUrl;
      if (!checkoutUrl) {
        throw new Error('无法创建 checkout');
      }

      window.location.href = checkoutUrl;
    } catch (error) {
      throw error;
    }
  }

  function initBuyNowButtons() {
    const buyNowButtons = document.querySelectorAll('.btn-buy-now');
    if (!buyNowButtons.length) {
      return;
    }

    const quantityInputSelector = 'input[name=\"quantity\"]';

    const handleButtonClick = async function(event) {
      event.preventDefault();

      if (this.disabled) {
        return;
      }

      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) {
        return;
      }

      const quantityInput = document.querySelector(quantityInputSelector);
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      this.disabled = true;
      const originalText = this.textContent;
      this.textContent = 'Processing...';

      try {
        await buyNowKeepCart(variantId, quantity);
      } catch (error) {
        this.disabled = false;
        this.textContent = originalText;
        console.error(error);
      }
    };

    buyNowButtons.forEach(button => {
      button.addEventListener('click', handleButtonClick);
    });

    document.addEventListener('variant:change', event => {
      const variantId = event.detail?.variant?.id;
      const available = event.detail?.variant?.available;

      if (!variantId) {
        return;
      }

      buyNowButtons.forEach(button => {
        button.setAttribute('data-variant-id', variantId);
        button.disabled = available === false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoCopyButtons);
    document.addEventListener('DOMContentLoaded', initBuyNowButtons);
  } else {
    initPromoCopyButtons();
    initBuyNowButtons();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    function copyPromoCodeText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textArea);
      }
    });
  }

  function initPromoCopyButtons() {
    const promoCopyButtons = document.querySelectorAll('.promo-banner__copy-button');

    if (!promoCopyButtons.length) {
      return;
    }

    promoCopyButtons.forEach(button => {
      if (button.dataset.copyBound === 'true') {
        return;
      }

      button.dataset.copyBound = 'true';

      button.addEventListener('click', async () => {
        const promoCode = button.dataset.copyText?.trim();
        const defaultLabel = button.dataset.copyLabel || 'COPY';

        if (!promoCode) {
          return;
        }

        try {
          await copyPromoCodeText(promoCode);
          button.textContent = button.dataset.copiedLabel || 'COPIED!';
          button.classList.add('is-copied');

          if (button.copyResetTimeout) {
            window.clearTimeout(button.copyResetTimeout);
          }

          button.copyResetTimeout = window.setTimeout(() => {
            button.textContent = defaultLabel;
            button.classList.remove('is-copied');
          }, 2000);
        } catch (error) {
          console.error('Failed to copy promo code', error);
        }
      });
    });
  }

  // Buy Now 按钮 - 使用 Storefront API 创建独立 checkout（不影响购物车）
  const STOREFRONT_TOKEN = 'f828427979a7f9ca220b123a9e032dfe';
  const STOREFRONT_ENDPOINT = 'https://oxilam.com/api/2024-10/graphql.json';
  const BUY_NOW_MUTATION = `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          checkoutUrl
        }
        userErrors {
          message
          field
        }
      }
    }
  `;

  async function buyNowKeepCart(variantId, quantity) {
    try {
      const response = await fetch(STOREFRONT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: BUY_NOW_MUTATION,
          variables: {
            input: {
              lines: [{
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                quantity: parseInt(quantity, 10) || 1
              }]
            }
          }
        })
      });

      const data = await response.json();

      if (data.data?.cartCreate?.userErrors?.length) {
        throw new Error(data.data.cartCreate.userErrors[0].message);
      }

      const checkoutUrl = data.data?.cartCreate?.cart?.checkoutUrl;
      if (!checkoutUrl) {
        throw new Error('无法创建 checkout');
      }

      window.location.href = checkoutUrl;
    } catch (error) {
      throw error;
    }
  }

  function initBuyNowButtons() {
    const buyNowButtons = document.querySelectorAll('.btn-buy-now');
    if (!buyNowButtons.length) {
      return;
    }

    const quantityInputSelector = 'input[name=\"quantity\"]';

    const handleButtonClick = async function(event) {
      event.preventDefault();

      if (this.disabled) {
        return;
      }

      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) {
        return;
      }

      const quantityInput = document.querySelector(quantityInputSelector);
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      this.disabled = true;
      const originalText = this.textContent;
      this.textContent = 'Processing...';

      try {
        await buyNowKeepCart(variantId, quantity);
      } catch (error) {
        this.disabled = false;
        this.textContent = originalText;
        console.error(error);
      }
    };

    buyNowButtons.forEach(button => {
      button.addEventListener('click', handleButtonClick);
    });

    document.addEventListener('variant:change', event => {
      const variantId = event.detail?.variant?.id;
      const available = event.detail?.variant?.available;

      if (!variantId) {
        return;
      }

      buyNowButtons.forEach(button => {
        button.setAttribute('data-variant-id', variantId);
        button.disabled = available === false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoCopyButtons);
    document.addEventListener('DOMContentLoaded', initBuyNowButtons);
  } else {
    initPromoCopyButtons();
    initBuyNowButtons();
  }
  } catch(e) { console.error(e); }
})();

})();
